module.exports = __webpack_public_path__ + "img/user.bfcf0198.svg";